//#region src/kiosk_external_touch_display_state.ts
var KioskExternalTouchDisplayState = /* @__PURE__ */ function(KioskExternalTouchDisplayState) {
	KioskExternalTouchDisplayState["NotRequired"] = "not-required";
	KioskExternalTouchDisplayState["Connecting"] = "connecting";
	KioskExternalTouchDisplayState["Connected"] = "connected";
	KioskExternalTouchDisplayState["Disconnected"] = "disconnected";
	return KioskExternalTouchDisplayState;
}(KioskExternalTouchDisplayState || {});
//#endregion
export { KioskExternalTouchDisplayState };

//# sourceMappingURL=kiosk_external_touch_display_state.js.map